import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { SunglassesRxableSelect } from "./SunglassesRxableSelect.js";
import { useSunglassesEcommContext } from "../../../../../../../context/modules/EcommContent/SunglassesEcommContent/context/SunglassesEcommContext.js";
import { isRxRadioSelection } from "../../../../../../../../components/RxableSelect/modules/EcommContent/components/RxableSelect/is-rx-radio-selection.js";
import { ProductAnalyticsEvents } from "../../../../../../../../../Analytics/events/modules/Analytics/events/ProductAnalyticsEvents.js";
import { WITHOUT_RX, WITH_RX } from "../../../../../../../../components/RxableSelect/modules/EcommContent/components/RxableSelect/contants.js";
const SunglassesRxableSelectContainer = ({ className }) => {
  const { selectWithRxLens, setSelectWithRxLens } = useSunglassesEcommContext();
  const { getLabel } = useIntl();
  const radioButtonItems = React.useMemo(
    () => [
      {
        value: WITHOUT_RX,
        label: getLabel("products.selectRxAble.withoutRx"),
        iconName: "sunglasses"
      },
      {
        value: WITH_RX,
        label: getLabel("products.selectRxAble.withRx"),
        iconName: "store-eye-test"
      }
    ],
    [getLabel]
  );
  const onRxRadioChange = React.useCallback(
    (newSelection) => {
      if (isRxRadioSelection(newSelection) && selectWithRxLens !== newSelection) {
        setSelectWithRxLens(newSelection);
        ProductAnalyticsEvents.pushPdpSunglassesRxSelectionEvent(newSelection === WITH_RX);
      }
    },
    [selectWithRxLens, setSelectWithRxLens]
  );
  return /* @__PURE__ */ React.createElement(
    SunglassesRxableSelect,
    {
      items: radioButtonItems,
      onChange: onRxRadioChange,
      selectedValue: selectWithRxLens,
      className
    }
  );
};
export {
  SunglassesRxableSelectContainer
};
//# sourceMappingURL=SunglassesRxableSelectContainer.js.map
